<template>
  <button
    :class="combinedClass"
    :disabled="disabled"
    @click="$emit('click', $event)"
  >
    <slot />
  </button>
</template>

<script setup>
import { computed, defineProps, defineEmits } from 'vue';

const props = defineProps({
  variant: {
    type: String,
    default: 'default',
    validator: (v) => ['default', 'primary', 'secondary', 'subtle'].includes(v),
  },
  disabled: {
    type: Boolean,
    default: false,
  },
});

defineEmits(['click']);

const baseClass =
  'px-4 flex items-center py-2 rounded-md text-sm font-medium transition-colors duration-100 disabled:cursor-not-allowed focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ocean-400';

const variantClasses = {
  default:
    'bg-steel-100 text-steel-900 hover:bg-steel-300 active:bg-steel-400 disabled:opacity-50 disabled:hover:bg-steel-100 disabled:active:bg-steel-100',
  primary:
    'bg-sun-400 text-steel-1100 hover:bg-sun-500 active:bg-sun-600 disabled:bg-steel-300 disabled:opacity-50',
  secondary:
    'bg-steel-900 text-steel-200 hover:bg-steel-1000 active:bg-steel-1100 disabled:bg-steel-900 disabled:text-steel-400',
  subtle:
    'border border-steel-300 bg-white text-steel-900 hover:bg-steel-300 active:bg-steel-400 disabled:opacity-50 disabled:hover:bg-transparent disabled:active:bg-transparent',
};

const combinedClass = computed(
  () => `${baseClass} ${variantClasses[props.variant]}`
);
</script>
